var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"latest-posts"},[_c('h4',[_vm._v("Latest Blog posts")]),_c('ul',_vm._l((_vm.blogTitles.slice().reverse()),function(articleId){return _c('li',{key:articleId},[_c('blog-posts-link',_vm._b({},'blog-posts-link',articleId,false))],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }